import React from "react";
import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../../../components/Converter";
import KiloNewtonDividedByMillimetreSquared from "../../../../../../components/Math/Units/Metric/KiloNewtonDividedByMillimetreSquared";
import { RowBody } from "../../../../../../components/RowValue/RowBody";

function Zylinderdruckfestigkeit({ zylinderdruckfestigkeit }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.parameterGroutingBody.cylinderStrength")}</p>}
      indicesValue={
        <span>
          f<sub>c,k</sub>
        </span>
      }
      inputValue={<span className="input">{ConvertToString(zylinderdruckfestigkeit)}</span>}
      unitValue={<KiloNewtonDividedByMillimetreSquared />}
    />
  );
}

export default Zylinderdruckfestigkeit;
